import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ShareConfigService {
    public suggestionOptionsForCalendar:any = [
        {
          "title":"Calendar",
          "code":"Calendar",
          "icon":"assets/layouts/img/cal-icon.png",
          "suggestions": new Array<any>()
        },
        {
            "title":"Appointment",
            "code":"Appointment",
            "icon":"assets/layouts/img/de-list.png",
            "suggestions": new Array<any>()
        }
    ];

    public suggestionOptionsForAppointment:any = [
      {
        "title":"Appointment",
        "code":"Appointment",
        "icon":"assets/layouts/img/de-list.png",
        "suggestions": new Array<any>()
    },
      {
        "title":"Calendar",
        "code":"Calendar",
        "icon":"assets/layouts/img/cal-icon.png",
        "suggestions": new Array<any>()
      },
      {
        "title":"Tag",
        "code":"Tag",
        "icon":"assets/layouts/img/automation-tag.png",
        "suggestions": new Array<any>()
    }
  ];

    public suggetionFilters: any = [
        {
          "filterTitle": "Calendar",
          "searchName": "Calendar",
          "searchValue": "",
          "type": "single",
          "searchOperator": "contain"
        },
        {
          "filterTitle": "Appointment",
          "searchName": "Appointment",
          "searchValue": "",
          "type": "single",
          "searchOperator": "contain"
        },
        {
          "filterTitle": "Quick Search",
          "searchName": "qSearch",
          "searchValue": "",
          "type": "single",
          "searchOperator": "contain"
        }
    ];

    public suggetionFiltersForAppointment: any = [
      {
        "filterTitle": "Calendar",
        "searchName": "Calendar",
        "searchValue": "",
        "type": "single",
        "searchOperator": "contain"
      },
      {
        "filterTitle": "Appointment",
        "searchName": "Appointment",
        "searchValue": "",
        "type": "single",
        "searchOperator": "contain"
      },
      {
          "filterTitle": "Tags",
          "searchName": "Tag",
          "searchValue": "",
          "type": "single",
          "searchOperator": "contain"
      },
      {
        "filterTitle": "Quick Search",
        "searchName": "qSearch",
        "searchValue": "",
        "type": "single",
        "searchOperator": "contain"
      }
  ];

  public languageNameByCode: any = {};
  public clientWhatsappTemplates: any = {};
  public whataAppTemplatePayload: any = {};

  public defualtLanguageCode: string = 'nl-NL';
  public selectedWhatsAppTemplate: any = {};
  public isEditAppointmentType: boolean = false;

  public listOfUsedVariableObj: any = {};
  public selectedHSMTemplateDetails: any = {};
  public deletedHSMTemplateFor: any = [];



    private isSearchSection = new BehaviorSubject(false);
    currentSearchSection = this.isSearchSection.asObservable();

    public appointmentSuggestionFilteredData: any = {};
    public appointmentSuggestionFilteredDataObservable = new BehaviorSubject(this.appointmentSuggestionFilteredData);

    changeAppointmentSuggestionFilteredData(){
      this.appointmentSuggestionFilteredDataObservable.next(this.appointmentSuggestionFilteredData);
    }

    public isValidWhatsAppTemplate: boolean = false;
    public isValidWhatsAppTemplateObservable = new BehaviorSubject(this.isValidWhatsAppTemplate);

    changeIsValidWhatsAppTemplate(){
      this.isValidWhatsAppTemplateObservable.next(this.isValidWhatsAppTemplate);
    }

    public appointmentTypeSuggestionFilteredData: any = {};
    public appointmentTypeSuggestionFilteredDataObservable = new BehaviorSubject(this.appointmentTypeSuggestionFilteredData);

    changeAppointmentTypeSuggestionFilteredData(){
      this.appointmentTypeSuggestionFilteredDataObservable.next(this.appointmentTypeSuggestionFilteredData);
    }

    public quizTagsReadyToFilter: any = {};
    public quizTagsReadyToFilterObservable = new BehaviorSubject(this.quizTagsReadyToFilter);

    changeQuizTagsReadyToFilter(){
      this.quizTagsReadyToFilterObservable.next(this.quizTagsReadyToFilter);
    }

    public activeCommunicationTab: number = 0;
    public activeCommunicationTabObservable = new BehaviorSubject(this.activeCommunicationTab);

    changeActiveCommunicationTab(){
      this.activeCommunicationTabObservable.next(this.activeCommunicationTab);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/shareConfig.service.ts